// extracted by mini-css-extract-plugin
module.exports = {"iFrame":"vFNzOJi"};